// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2zIAw","title":"BackImages_title__2tRSn","images":"BackImages_images__3ThxO"};